import { useQuery } from '@tanstack/react-query';
import { fetchPublicPropertyDetail, PublicPropertyDetail } from '../../infrastructure/api/publicPropertyApi';

export function usePublicPropertyDetails(propertyId: string | null) {
  const query = useQuery({
    queryKey: [ 'publicPropertyDetail', propertyId ],
    queryFn: () => fetchPublicPropertyDetail(propertyId!),
    enabled: !!propertyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    propertyDetails: query.data || null,
    isLoading: query.isLoading,
    error: query.error,
    isError: query.isError,
  };
}
